import ComponentNotFound from "./component-not-found"

import Page from "./page"
import ExecEdPage from "./page-execed"
import PageLanding from "./page-landing"
import ExecEdPageLanding from "./page-landing-execed"
import Link from "./link"
import Button from "./button"
import Hero from "./hero"
import HeroFull from "./hero-full"
import HeroLanding from "./hero-landing"
import HeroForm from "./hero-form"
import SimpleHero from "./simple-hero"
import Location from "./location"
import LocationCta from "./location-cta"
import Campus from "./campus"
import Brochure from "./brochure"
import BrochureAlt from "./brochure-alt"
import Social from "./social"
import ProgramList from "./program-list"
import Blog from "./blog"
import Event from "./event"
import Academic from "./academic"
import Section from "./section"
import SectionFull from "./section-full"
import SectionSplit from "./section-split"
import Grid from "./grid"
import Column from "./column"
import Stat from "./stat"
import Video from "./video"
import Table from "./table"
import Row from "./row"
import Value from "./value"
import ApplyStep from "./apply-step"
import Navigation from "./navigation"
import ImageCard from "./image-card"
import Image from "./image"
import CourseList from "./course-list"
import Course from "./course"
import Module from "./module"
import History from "./history"
import LandingHero from "./landing-hero"
import Carousel from "./carousel"
import Testimonial from "./testimonial"
import Card from "./card"
import UserCard from "./user-card"
import Spacer from "./spacer"
import CallToAction from "./call-to-action"
import FormStack from "./formstack-form"
import Marketo from "./marketo-form"
import InstagramWidget from "./instagram-widget"
import Mozaic from "./mozaic"
import SuperGrid from "./super-grid"
import SuperColumn from "./super-column"
import SuperBlock from "./super-block"
import CrumbTrail from "./crumb-trail"
import Tag from "./tag"
import FacultySearch from "./faculty-search"
import EventSearch from "./event-search"
import EventDetail from "./event-detail"
import EventDiscovery from "./event-discovery"
import EventsPromo from "./events-promo"
import EventResults from "./event-results"
import EventFilter from "./event-filter"
import Profile from "./profile"
import Quote from "./quote"
import EmbedCode from "./embed-code"
import LightningOut from "./lightningOut"
import CookieNotice from "./cookie-notice"
import ClickableArea from "./clickable-area"
import EFSet from "./ef-set"
import SubNav from "./sub-nav"
import AshridgePayments from "./ashridge-payment"
import AmbassadorSearch from "./ambassador-search"
import AmbassadorProfile from "./ambassador-profile"
import ContactMethodLink from "./contact-method-link"
import Optimize from "./optimize"
import OptimizeVariant from "./optimize-variant"
import CareersSearch from "./careers-search"
import CareersJob from "./careers-job"
import CalendlyForm from "./calendly-form"
import HeroEvent from "./hero-event"
import IconText from "./icon-text"
import ImageFocusPoint from "./image-focus-point"
import Alert from "./alert"
import Ranking from "./ranking"
import ChatBot from "./chat-bot"
import PardotForm from "./pardot-form"
import FooterGroup from "./footer-group"
import FormMailChimp from "./form-mailchimp"
import YouVisit from "./you-visit"
import StudentApp from "./student-app"
import GlobalHeader from "./global-header/GlobalHeader"
import { StudentLogin } from "./student-app-login-embed"
import NotificationBar from "./global-header/NotificationBar"

// New v2 Components
import HeroV2 from "./hero-v2"
import HeroV2Form from "./hero-v2-form"
import HeroV2Modal from "./hero-v2-modal"
import HeroStudentApp from "./hero-student-app"
import ButtonV2 from "./button-v2"
import NavigationV2 from "./navigation-v2"
import CallToActionV2 from "./call-to-action-v2"
import GlobalReference from "./global-reference"
import ProgramCategory from "./program-category"
import ProgramGroup from "./program-group"
import GlobalContent from "./global-content"
import {
    StoryblokFormWrapper,
    StoryblokFormField,
    StoryblokFormCopy,
    StoryblokForm,
    StoryblokEventForm,
    StoryblokEventFormWrapper,
} from "./form"
import PageLandingV2 from "./page-landing-v2"
import ProgramDetail from "./program-detail"
import ProgramDetailAttr from "./program-detail-attr"
import GridV2 from "./grid-v2"
import CardV2 from "./card-v2"
import HeroV2Share from "./hero-v2-share"
import { Testimonials, TestimonialsWrapper } from "./testimonials-v2"

// S22
import S22Page from "./s22_page"
import S22HeroDegree from "./s22_hero-degree"
import { S22Card } from "./s22_card"
import { S22Attribute } from "./s22_card"
import S22CardEvent from "./s22_card-event"
import S22List from "./s22_list"
import S22Skills from "./s22_skills"
import S22Pills from "./s22_pills"
import S22Stats from "./s22_stats"
import S22Footer from "./s22_footer"
import S22Bookings from "./s22_bookings-1-2-1"
import S22FooterGroup from "./s22_footer-group"
import S22Media from "./s22_media"
import S22Table from "./s22_table"
import S22Accordion from "./s22_accordion"
import S22CourseTemplate from "./s22_course-template"
import S22Overview from "./s22_overview"
import S22Hero from "./s22_hero"
import {
    S22HeroNew,
    S22HeroForm,
    S22HeroHighlight,
    S22HeroFullBleed,
    S22HeroFormAttr,
} from "./s22_hero-new"
import { S22Section, S22SectionOffset, S22SectionGroup } from "./s22_section"
import { S22Grid, S22Column } from "./s22_grid"
import { S22HeroHomepage } from "./s22_hero-homepage"
import S22Carousel from "./s22_carousel"
import { S22ModalReference } from "./s22_modal/ModalReference"
import { S22ModalContent } from "./s22_modal/ModalContent"
import { S22ModalSection } from "./s22_modal/ModalSection"
import { S22WeekInLife } from "./s22_week-in-life/WeekInLife"
import S22Text from "./s22_text"
import S22Translate from "./s22_translate"
import S22Review from "./s22_review"
import S22CardHover from "./s22_card-hover"
import S22SocialFeed from "./s22_social-feed"
import S22ProgramOverview from "./s22_overview-program"
import S22ProgramCard from "./s22_program-card"
import S22BBAWidget from "./s22_bba-widget"
import S22AddToCalendar from "./s22_add-to-calendar"
import S22FixedHeader from "./s22_fixed-header"
import S22CardProfile from "./s22_card-profile"

//S23C
import S23CPage from "./s23c_page"
import S23CHeroCentered from "./s23c_hero-centered"
import S23CHeroLeft from "./s23c_hero-left"
import S23CSection from "./s23c_section"
import S23CSubSectionTitle from "./s23c_subsection-title"
import { S23CSubSection, S23CColumn } from "./s23c_subsection"
import { S23CCardResearch, S23CCardResearchSmall, S23CCardIcon, S23CCardEvent } from "./s23c_card"
import S23CMedia from "./s23c_media"
import S23CText from "./s23c_text"

// 2024
import Tabs from "./tabs"

const ComponentList = {
    page: Page,
    page_execed: ExecEdPage,
    page_landing: PageLanding,
    page_execed_landing: ExecEdPageLanding,
    academic: Academic,
    ashridgePayment: AshridgePayments,
    ambassadorSearch: AmbassadorSearch,
    ambassadorProfile: AmbassadorProfile,
    contactMethodLink: ContactMethodLink,
    applyStep: ApplyStep,
    blog: Blog,
    chatBot: ChatBot,
    brochure: Brochure,
    brochureAlt: BrochureAlt,
    button: Button,
    callToAction: CallToAction,
    campus: Campus,
    card: Card,
    carousel: Carousel,
    clickableArea: ClickableArea,
    careersSearch: CareersSearch,
    careersJob: CareersJob,
    column: Column,
    cookieNotice: CookieNotice,
    course: Course,
    courseList: CourseList,
    crumbTrail: CrumbTrail,
    eventFormWrapper: StoryblokEventFormWrapper,
    eventForm: StoryblokEventForm,
    storyblokFormWrapper: StoryblokFormWrapper,
    storyblokForm: StoryblokForm,

    storyblokFormField: StoryblokFormField,
    storyblokFormCopy: StoryblokFormCopy,
    efSet: EFSet,
    embed_code: EmbedCode,
    event: Event,
    event_search: EventSearch,
    event_detail: EventDetail,
    eventDiscovery: EventDiscovery,
    eventsPromo: EventsPromo,
    eventResults: EventResults,
    eventFilter: EventFilter,
    faculty_search: FacultySearch,
    formstack_form: FormStack,
    grid: Grid,
    hero: Hero,
    heroFull: HeroFull,
    heroLanding: HeroLanding,
    heroForm: HeroForm,
    history: History,
    image: Image,
    imageCard: ImageCard,
    instagram_widget: InstagramWidget,
    landingHero: LandingHero,
    lightningOut: LightningOut,
    link: Link,
    location: Location,
    locationCta: LocationCta,
    marketo_form: Marketo,
    module: Module,
    mozaic: Mozaic,
    navigation: Navigation,
    profile: Profile,
    programList: ProgramList,
    quote: Quote,
    row: Row,
    section: Section,
    sectionFull: SectionFull,
    sectionSplit: SectionSplit,
    simpleHero: SimpleHero,
    social: Social,
    spacer: Spacer,
    stat: Stat,
    subNav: SubNav,
    superBlock: SuperBlock,
    superColumn: SuperColumn,
    superGrid: SuperGrid,
    table: Table,
    tag: Tag,
    testimonial: Testimonial,
    text: S22Text,
    pardotForm: PardotForm,
    userCard: UserCard,
    value: Value,
    video: Video,
    optimize: Optimize,
    optimize_variant: OptimizeVariant,
    calendlyForm: CalendlyForm,
    heroEvent: HeroEvent,
    iconText: IconText,
    imageFocusPoint: ImageFocusPoint,
    alert: Alert,
    ranking: Ranking,
    footerGroup: FooterGroup,
    formMailChimp: FormMailChimp,
    youVisit: YouVisit,
    studentApp: StudentApp,
    "student-app-login-embed": StudentLogin,

    // New v2 Components
    heroV2: HeroV2,
    heroV2Form: HeroV2Form,
    heroV2Modal: HeroV2Modal,
    heroStudentApp: HeroStudentApp,
    buttonV2: ButtonV2,
    navigationV2: NavigationV2,
    callToActionV2: CallToActionV2,
    global_reference: GlobalReference,
    programCategory: ProgramCategory,
    programGroup: ProgramGroup,
    globalcontent: GlobalContent,
    page_landing_v2: PageLandingV2,
    programDetail: ProgramDetail,
    programDetailAttr: ProgramDetailAttr,
    gridV2: GridV2,
    cardV2: CardV2,
    heroV2Share: HeroV2Share,
    testimonialsV2: Testimonials,
    testimonialsWrapper: TestimonialsWrapper,
    global_header: GlobalHeader,
    global_header_config: GlobalHeader,
    notification_bar: NotificationBar,

    // S22
    s22_page: S22Page,
    s22_grid: S22Grid,
    s22_column: S22Column,
    "s22_hero-degree": S22HeroDegree,
    s22_card: S22Card,
    s22_attribute: S22Attribute,
    "s22_card-event": S22CardEvent,
    s22_list: S22List,
    s22_skills: S22Skills,
    s22_pills: S22Pills,
    s22_stats: S22Stats,
    s22_footer: S22Footer,
    s22_bookings: S22Bookings,
    "s22_footer-group": S22FooterGroup,
    s22_media: S22Media,
    s22_table: S22Table,
    s22_accordion: S22Accordion,
    "s22_course-template": S22CourseTemplate,
    s22_overview: S22Overview,
    s22_hero: S22Hero,
    "s22_hero-new": S22HeroNew,
    "s22_hero-form": S22HeroForm,
    "s22_hero-form-event": S22HeroForm,
    "s22_hero-highlight": S22HeroHighlight,
    "s22_hero-full-bleed": S22HeroFullBleed,
    "s22_hero-form-attr": S22HeroFormAttr,
    s22_section: S22Section,
    "s22_section-offset": S22SectionOffset,
    "s22_section-group": S22SectionGroup,
    "s22_hero-homepage": S22HeroHomepage,
    s22_carousel: S22Carousel,
    "s22_modal-reference": S22ModalReference,
    "s22_modal-content": S22ModalContent,
    "s22_modal-section": S22ModalSection,
    "s22_week-in-life": S22WeekInLife,
    s22_translate: S22Translate,
    s22_review: S22Review,
    "s22_card-hover": S22CardHover,
    "s22_social-feed": S22SocialFeed,
    "s22_overview-program": S22ProgramOverview,
    "s22_program-card": S22ProgramCard,
    "s22_bba-widget": S22BBAWidget,
    "s22_add-to-calendar": S22AddToCalendar,
    "s22_fixed-header": S22FixedHeader,
    "s22_card-profile": S22CardProfile,

    //S23C
    s23c_page: S23CPage,
    "s23c_hero-centered": S23CHeroCentered,
    "s23c_hero-left": S23CHeroLeft,
    s23c_section: S23CSection,
    "s23c_subsection-title": S23CSubSectionTitle,
    s23c_subsection: S23CSubSection,
    "s23c_card-research": S23CCardResearch,
    "s23c_card-research-small": S23CCardResearchSmall,
    "s23c_card-icon": S23CCardIcon,
    "s23c_card-event": S23CCardEvent,
    s23c_column: S23CColumn,
    s23c_media: S23CMedia,
    s23c_text: S23CText,

    // 2024
    tabs: Tabs,
}

const Components = (type) => {
    if (typeof ComponentList[type] === "undefined") {
        return ComponentNotFound
    }
    return ComponentList[type]
}

export default Components